import { Typography } from '@mui/material';
import { LogoField } from '@truvhq/ui';

import { useUpdateLogo } from 'entities/user/api/useUpdateLogo';
import { useGetWidgetSettings } from 'hooks/customization';
import { useShowFileSizeError } from 'shared/lib/validation/useShowFileSizeError';
import { AuthLayoutTemplate } from 'shared/ui/AuthLayoutTemplate';

import { CompleteFormIndividual } from './CompleteFormIndividual';

export const CompleteIndividual = () => {
  const { updateLogo, isLogoUpdating } = useUpdateLogo();
  const { data: widgetSettings } = useGetWidgetSettings();

  const showSizeError = useShowFileSizeError();

  return (
    <AuthLayoutTemplate pageName="CompleteIndividual">
      <div>
        <Typography className="pb-3 text-[34px] font-bold" variant="h1">
          Welcome to Truv
        </Typography>
        <Typography className="pb-10" color="textSecondary">
          Fill in the below information to finish setting up your Truv Dashboard.
        </Typography>

        <LogoField
          caption="This logo will be displayed in the emails and verification screens sent to borrowers."
          isLoading={isLogoUpdating}
          value={widgetSettings?.logo ?? null}
          onChange={updateLogo}
          onSizeError={showSizeError}
        />

        <CompleteFormIndividual />
      </div>
    </AuthLayoutTemplate>
  );
};
